import { ethers, Wallet } from 'ethers';
import {
  decryptLegacyPrivateKey,
  decryptMnemonic,
} from '@nerdcoresdk/foundations-crypto';
// Resources
import { getLegacySalts, getMemberSalts } from '@/resources/wallet-service.resource';
export const ERC20_ABI = [
  {
    constant: true,
    inputs: [{ name: '_owner', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: 'balance', type: 'uint256' }],
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    type: 'function',
  },
];

// -----Getting and Decrypting mnemonic for signing transactions-----
export async function fetchEncryptedMnemonic(fetcher) {
  // get encrypted data from api
  return await fetcher(getMemberSalts())
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });
}

export function calculateTokenAmount(amount, decimals) {
  try {
    const result = ethers.utils.parseUnits(amount.toString(), decimals);
    return result;
  } catch (err) {
    console.error('Error calculating token amount:', {
      error: err.message,
      input: amount,
      decimals,
    });
    throw err;
  }
}

export function formatTokenAmount(amount, decimals) {
  try {
    const result = ethers.utils.formatUnits(amount, decimals);
    return result;
  } catch (err) {
    console.error('Error formatting token amount:', {
      error: err.message,
      input: amount.toString(),
      decimals,
    });
    throw err;
  }
}

export async function prepareWallet(fetcher, passcode, rpcProvider) {
  const encryptedData = await fetchEncryptedMnemonic(fetcher);
  if (!encryptedData) throw new Error('No encrypted data available');

  const mnemonic = await decryptMnemonic(encryptedData, passcode);
  const wallet = Wallet.fromMnemonic(mnemonic).connect(rpcProvider);
  return wallet;
}

export async function getTokenQuote(fromToken, toToken, amount, provider) {
  try {
    // Create contract instances
    const tokenOutContract = new ethers.Contract(toToken.address, ERC20_ABI, provider);

    try {
      // Get balance using v5 syntax
      const balance = await tokenOutContract.balanceOf(provider.address);

      const amountIn = ethers.utils.parseUnits(amount.toString(), fromToken.decimals);

      const formattedQuote = ethers.utils.formatUnits(balance, toToken.decimals);

      return {
        amountIn,
        amountOut: balance,
        formattedQuote,
      };
    } catch (err) {
      console.error('Error getting token balance:', {
        error: err.message,
        code: err.code,
        tokenAddress: toToken.address,
        providerAddress: provider.address,
      });
      throw err;
    }
  } catch (err) {
    console.error('Fatal error in getTokenQuote:', {
      error: err.message,
      code: err.code,
      stack: err.stack,
    });
    throw err;
  }
}

export async function fetchAndDecryptLegacyPrivateKey(from, passcode, fetcher) {
  const encryptedPrivateKey = await fetchLegacyEncryptedPrivateKey(from, fetcher);
  if (!encryptedPrivateKey) {
    throw new Error('No encrypted Legacy private key available');
  }

  return decryptLegacyPrivateKey(encryptedPrivateKey, passcode);
}

export const fetchLegacyEncryptedPrivateKey = (from, fetcher) =>
  fetcher(getLegacySalts(from));
